<template>
	<div class="popup-credits">
		<div class="bg" v-bg="'credits/bg-credits.png'"></div>
		<div class="content">
			<div class="title">{{ 'credits' | lang }}</div>
			<div class="credits">
				<div v-for="credit in credits" :key="credit.slug" class="credit">
					<div class="portrait" v-bg="'credits/' + credit.slug + '.png'"></div>
					<div class="name"><span>{{ credit.name }}</span></div>
					<div class="role"><span>{{ credit.role | lang }}</span></div>
					<div class="website"><a target="blank" :href="credit.url">{{ credit.url_text }}</a></div>
				</div>
			</div>
			<div class="buttons">
				<ui-button v-hammer:tap="close">{{ 'close' | lang }}</ui-button>
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import UiButton from '@/components/ui/ui-button'
import { shuffle } from '@/js/utils'

export default {
	name: 'popup-credits',
	data() {
		return {
			credits: []
		}
	},
	props: {
		popup: { default: null }
	},
	computed: {
		...mapGetters([ 'lang' ]),
	},
	methods: {
		close(e) {
			if (!e.srcEvent.stopped) this.$emit('close')
		}
	},
	created() {
		this.credits = shuffle([
			{ slug: 'christophe', name: "Christophe Coyard", role: "developer", url: "https://twitter.com/twotinydice", url_text: "@twotinydice" },
			{ slug: 'jeanne', name: "Jeanne Prigent", role: "game_artist", url: "https://twitter.com/JanePrigent", url_text: "@JanePrigent" },
			{ slug: 'damien', name: "Nox", role: "sound_designer", url: "https://www.instagram.com/noxsounddesign/", url_text: "@noxsounddesign" }
		])
	},
	components: { UiButton }
}
</script>

<style lang="stylus" scoped>
@import '../../../assets/css/variables'


.popup-credits
	absolute 0
	color #fff
	flex center center
	text-align center
	.bg
		absolute 0
	.content
		// height 100%
		width calc(100% - 32px)
		max-width 1100px
		border-radius 16px
		margin 0 auto
		flex center center column
		transform translateY(-24px)
		background-color #fff
		color dark
		box-shadow -4px 6px alpha(#000, 25%)
		.title
			font-size 8rem
			background-color dark
			color #fff
			transform translateY(-50%)
			padding 24px 48px
			border-radius 16px
		.credits
			width 100%
			flex center center
			padding 0 0 64px 0
			.credit
				flex center center column
				margin 0 64px
				font-size 4rem
				.portrait
					margin 0 0 16px 0
					width 180px
					height 180px
					border-radius 50%
					background center center no-repeat
					background-size contain
				.name
					width 100%
					margin 0 0 0px 0
				.role
					width 100%
					margin 0 0 16px 0
					color #aaa
				.website
					width 100%
					margin 0 0 8px 0
					font-size 3.2rem
					a
						color dark
						text-decoration underline
						&:hover
							text-decoration none
		.buttons
			position absolute
			top calc(100% + 32px)

</style>
